"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeSearchQueryField = void 0;
var _range = require("./range");
var _simpleSearchQueryField = require("./simple-search-query-field");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class RangeSearchQueryField extends _simpleSearchQueryField.SimpleSearchQueryField {
  constructor(searchOptions, value) {
    var rangeValue = value ? new _range.Range(value) : null;
    super(searchOptions, (rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.getObject()) || null);
    _defineProperty(this, "range", void 0);
    this.range = rangeValue;
  }
  getUrlParameterValue() {
    if (!this.range || this.range.isEmpty()) {
      return null;
    }
    return this.range.min === this.range.max ? "".concat(this.range.min) : "".concat(this.range.min || '', "-").concat(this.range.max || '');
  }
  get value() {
    var _this$range, _this$range2;
    return (_this$range = this.range) !== null && _this$range !== void 0 && _this$range.isEmpty() ? null : ((_this$range2 = this.range) === null || _this$range2 === void 0 ? void 0 : _this$range2.getObject()) || null;
  }
  getSingleValue() {
    var _this$range$getSingle, _this$range3;
    return (_this$range$getSingle = (_this$range3 = this.range) === null || _this$range3 === void 0 ? void 0 : _this$range3.getSingleValue()) !== null && _this$range$getSingle !== void 0 ? _this$range$getSingle : null;
  }
}
exports.RangeSearchQueryField = RangeSearchQueryField;